<template>
  <div>
    <div class="login-box">
      <div class="middle-box text-center animated fadeInDown">
        <div>
          <div>
            <img class="login-logo" src="../../../assets/img/logo.png">

          </div>
          <h3 class="login-title">领鲜收银（商户端）</h3>
          <form class="m-t" role="form" onsubmit="return false">
            <div class="form-group">
              <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-user"></i></span>
                <input type="text" class="form-control" placeholder="账号" required v-model="credentials.name">
              </div>
            </div>
            <div class="form-group">
              <div class="input-group">
                <span class="input-group-addon"><i class="fa fa-lock"></i></span>
                <input type="password" class="form-control" placeholder="密码" required
                       v-model="credentials.password">
              </div>
            </div>
            <button type="submit" class="btn btn-primary block full-width m-b" @click="login">立即登录</button>
          </form>
        </div>
      </div>

    </div>
    <p class="footer back-bor-null"> &copy; 2017 freshone all rights reserved </p>
  </div>
</template>

<script>

  import auth from '../../../lib/auth';
  export default {
    data() {
      return {
        credentials: {
          name: '',
          password: ''
        }
      };
    },
    mounted() {
      auth.autoLogin(this, this.credentials).then(() => {
        router.push('main');
      }, (error) => {
        //自动登录不成功，用户正常登录
      });
    },
    methods: {
      login() {
        auth.login(this, this.credentials).then(() => {
          router.push('main');
        }, (error) => {
          //登陆失败报错
          error.data && this.$alert(error.data);
        });
      }
    }
  }
</script>

<style>
  .login-box{
    position: fixed;
    left: 50%;
    top: 40%;
    transform: translate(-50%,-50%);
    min-width: 320px;
  }
  .login-box .login-logo{
    width: 30%;
  }
  .login-box .login-title{
    color:#fff;
    font-size:18px;
    padding:20px 0 50px;
    font-family: "Microsoft YaHei";
    font-weight: normal;
  }
  .login-box .input-group .form-control{
    border-left: none;
  }
  .back-bor-null {
    background-color: #2f4050;
    border-top: medium none #2f4050;
    color: #758492;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// loginPage.vue?c9f3f58a